module.exports = __webpack_public_path__ + "media/smart_sales/step-4-cf9ce182.webp";